import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "./../assets/images/Logo.png";

function Header() {
  const [navigationToggler, setNavigationToggler] = useState(false);
  const [apps, setApps] = useState({});

  useEffect(() => {
    fetch("/apps/industry")
      .then(r => r.json())
      .then(data => setApps(data))
      .catch(() => {});
  }, []);

  const sections = [
    {
      label: null,
      items: [
        { label: "Home", path: "/", exact: true, countKey: null },
      ],
    },
    {
      label: "Industries",
      items: [
        { label: "Comms, Media & Tech",     path: "/communications-media-and-technology", countKey: "Communications, Media & Technology" },
        { label: "Financial Services",       path: "/financial-services",                  countKey: "Financial Services" },
        { label: "Health & Life Sciences",   path: "/health-and-life-sciences",            countKey: "Health & Life Sciences" },
        { label: "Products",                 path: "/products",                            countKey: "Products" },
        { label: "Resources",               path: "/resources",                           countKey: "Resources" },
      ],
    },
    {
      label: "Explore",
      items: [
        { label: "Notebooks",  path: "/notebooks",  countKey: "Notebooks" },
        { label: "Other",      path: "/other",      countKey: "Other" },
      ],
    },
  ];

  return (
    <nav className={navigationToggler ? "mi-header is-visible" : "mi-header"}>
      <button
        onClick={() => setNavigationToggler(!navigationToggler)}
        className="mi-header-toggler"
        aria-label="Toggle navigation"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className="mi-header-inner">
        <div className="mi-header-image">
          <Link to="/">
            <img src={Logo} alt="Quantum Hub" />
          </Link>
        </div>

        <nav className="mi-header-nav">
          {sections.map((section, si) => (
            <div key={si} className="mi-header-section">
              {section.label && (
                <div className="mi-header-section-label">{section.label}</div>
              )}
              <ul className="mi-header-menu">
                {section.items.map((item, i) => {
                  const count = item.countKey ? apps[item.countKey] : null;
                  return (
                    <li key={i}>
                      <NavLink exact={item.exact} to={item.path}>
                        <span className="nav-icon-dot" />
                        <span className="nav-label">{item.label}</span>
                        {count !== undefined && count !== null && (
                          <span className="nav-count">{count}</span>
                        )}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </nav>

        <p className="mi-header-copyright">
          &copy; {new Date().getFullYear()} <a href="/">Accenture</a>
        </p>
      </div>
    </nav>
  );
}

export default Header;
